/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_CustomerService_Dtos_Participant_GovernmentDocumentToDelete } from '../models/Wealthlane_CustomerService_Dtos_Participant_GovernmentDocumentToDelete';
import type { Wealthlane_CustomerService_Dtos_Participant_UpdateTaxInfoDto } from '../models/Wealthlane_CustomerService_Dtos_Participant_UpdateTaxInfoDto';
import type { Wealthlane_Shared_Hosting_Dtos_GenericApiResponse } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericApiResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ParticipantProfileService {

    /**
     * @returns Wealthlane_CustomerService_Dtos_Participant_UpdateTaxInfoDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiParticipantProfileTaxInfo(): CancelablePromise<Wealthlane_CustomerService_Dtos_Participant_UpdateTaxInfoDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/participant-profile/tax-info',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param formData
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static postApiCustomerApiParticipantProfileUpdateTaxInfo(
        formData?: {
            ResidenceStatusId?: string;
            CountryOfLegalResidenceId?: string;
            SocialSecurityNumberOrTaxId?: string;
            EmploymentStateText?: string;
            EmploymentStateId?: string;
            EmploymentCountryId?: string;
            FirstName: string;
            MiddleName?: string;
            LastName: string;
            GovernmentDocumentIdsToDelete?: Array<string>;
            GovernmentDocumentTypeId?: string;
            GovernmentDocumentIdNo?: string;
            GovernmentDocumentIdIssueDate?: string;
            GovernmentDocumentExpirationDate?: string;
            GovernmentDocuments?: Array<Blob>;
        },
    ): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/participant-profile/update-tax-info',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
